import React from 'react';
import 'react-toggle/style.css';
import styled from 'styled-components';

import IRhapsodyComponents from 'src/ServerEntities/IRhapsodyComponents';
import IRhapsodyServer from 'src/ServerEntities/IRhapsodyServer';
import ErrorBox from 'src/SharedComponents/ErrorBox';
import LoadingIndicator from 'src/SharedComponents/LoadingIndicator';
import { SessionContext } from 'src/Views/SessionContext';
import { getRhapsodyComponents, getRhapsodyHeader } from '../ramService';
import { ContentContainer } from '../Intersystems/IntersystemsDashboard';
import RhapsodyCommpoints from './RhapsodyCommpoints';
import RhapsodyRoutes from './RhapsodyRoutes';
import RhapsodyWebServices from './RhapsodyWebServices';
import useCookie from 'src/CustomHooks/useCookie';
import ServerSelector from 'src/SharedComponents/Select/ServerSelector';


const SiteContainer = styled.ul`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: stretch;
    margin-top: 20px;
    & > div {
        margin: 0 12px;
    }
    & > div:nth-child(1) {
        margin-left: 0;
    }
    & > div:nth-last-child(1) {
        margin-right: 0;
    }
`;

interface IProps {
    selectedTypes: string[],
    changeRole: boolean,
    setChangeRole: (changeRole: boolean) => void
};

const RhapsodyComponents = (props: IProps) => {
    const { state, dispatch } = React.useContext(SessionContext);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [selectedNamespace, setSelectedNamespace] = useCookie<string>('selectedNamespace', '');
    const [data, setData] = React.useState(undefined as unknown as IRhapsodyServer[]);
    const [components, setComponents] = React.useState(undefined as unknown as IRhapsodyComponents);
    const selectedServer = state.selectedSever ?? 0;

    const setSelectedServer = (index: number) => {
        dispatch({ type: "setSelectedServer", payload: index });
    };
    const headerInfo = state.headerInfo ? state.headerInfo : data;

    React.useEffect(() => {
        if (!state.headerInfo) {
            setLoading(true);
            getRhapsodyHeader(state.webToken, (serverData: IRhapsodyServer[]) => {
                setLoading(false);
                setData(serverData);
                setError("");
                loadComponents(serverData);
                dispatch({ type: "setHeaderInfo", payload: serverData });
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        } else {
            loadComponents(headerInfo);
        }
    }, [state.webToken, selectedServer]);

    const loadComponents = (header: IRhapsodyServer[]) => {
        setLoading(true);
        if (header && header[selectedServer]) {
            getRhapsodyComponents(header[selectedServer].id, state.webToken, (data: IRhapsodyComponents) => {
                setLoading(false);
                setComponents(data);
                setError("");
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        }
    }

    return <ContentContainer>
        <LoadingIndicator type="Linear" show={loading} />
        {error && <ErrorBox>{error}</ErrorBox>}
        <ServerSelector headerInfo={headerInfo} selectedNamespace={selectedNamespace} setSelectedNamespace={setSelectedNamespace} selectedServer={selectedServer} setSelectedServer={setSelectedServer} />
        <SiteContainer>
            {components && components.routes && <RhapsodyRoutes data={components.routes} />}
            {components && components.commpoints && <RhapsodyCommpoints data={components.commpoints} />}
            {components && components.webServices && <RhapsodyWebServices data={components.webServices} />}
        </SiteContainer>
    </ContentContainer>;
};

export default RhapsodyComponents;
